import { withFieldGroup } from '@massilia/features'
import { Label } from '@massilia/ui'

import type { CheckoutFormValues } from '../checkout-form.schema'

export const InstallmentsSubForm = withFieldGroup({
  defaultValues: {} as Pick<
    CheckoutFormValues,
    'billingCity' | 'billingCountryCode' | 'billingStreet' | 'billingZipCode'
  >,
  render: function InstallmentsSubFormFields({ group }) {
    return (
      <div className="flex flex-col gap-4">
        <p className="text-gray-light-700 text-sm">
          Vous serez redirigé vers notre plateforme de paiement sécurisée. Le choix entre 3 ou 4
          fois se fait sur la page de paiement.
        </p>

        {/* Billing address */}
        <div className="flex flex-col gap-3">
          <Label className="text-sm font-medium">Adresse de facturation</Label>

          <group.AppField name="billingStreet">
            {(field) => <field.TextField placeholder="N° et rue (ex : 25 Rue de Paris)" />}
          </group.AppField>

          <div className="flex gap-3">
            <group.AppField name="billingZipCode">
              {(field) => <field.TextField placeholder="Code postal" />}
            </group.AppField>

            <group.AppField name="billingCity">
              {(field) => <field.TextField placeholder="Ville" />}
            </group.AppField>
          </div>

          <group.AppField name="billingCountryCode">
            {(field) => <field.CountryAutocompleteField placeholder="Pays" />}
          </group.AppField>
        </div>
      </div>
    )
  },
})
